import React from 'react';
import '../../styles/Features.css';
// Si tu n'as pas encore installé react-icons : npm install react-icons
import { FaRobot, FaHandshake, FaShieldAlt, FaUserFriends } from 'react-icons/fa';

const Features = () => {
  const services = [
    {
      icon: <FaHandshake />,
      title: "Médiation Neutre",
      target: "Propriétaires & Locataires",
      desc: "Conflits de voisinage, impayés ou travaux ? Nous rétablissons le dialogue pour éviter les procédures longues et coûteuses."
    },
    {
      icon: <FaShieldAlt />,
      title: "Protection Juridique",
      target: "Pour tous",
      desc: "Accédez à une base de connaissances juridiques à jour pour connaître vos droits et devoirs réels, sans jargon complexe."
    },
    {
      icon: <FaUserFriends />,
      title: "Communauté Solidaire",
      target: "Réseau National",
      desc: "Rejoignez un réseau d'entraide bienveillant. Ne restez plus isolé face à vos difficultés de logement."
    }
  ];

  return (
    <div className="features-section">
      <div className="features-header">
        <h2 className="section-title">Des solutions modernes pour votre habitat</h2>
        <p className="section-subtitle">
          NMS 06 réinvente l'entraide logement en combinant expertise humaine et puissance technologique.
        </p>
      </div>
      
      <div className="features-grid">
        
        {/* --- LA CARTE STAR : L'IA (Mise en avant) --- */}
        <div className="feature-card ai-feature-card">
          <div className="ai-badge">Innovation NMS 06</div>
          <div className="icon-box ai-icon-box">
            <FaRobot />
          </div>
          <h3>Assistant IA Intelligent</h3>
          <p className="target-badge">Réservé aux Adhérents</p>
          <p className="feature-desc">
            Fini l'angoisse de la page blanche. Notre IA rédige pour vous :
          </p>
          <ul className="ai-list">
            <li>✨ Mises en demeure formelles</li>
            <li>✨ Demandes de délais de paiement</li>
            <li>✨ Signalements d'insalubrité</li>
          </ul>
          <button className="btn-feature-ai">Découvrir l'IA</button>
        </div>

        {/* --- LES AUTRES SERVICES --- */}
        {services.map((service, index) => (
          <div className="feature-card" key={index}>
            <div className="icon-box standard-icon">
              {service.icon}
            </div>
            <h3>{service.title}</h3>
            <p className="target-label">{service.target}</p>
            <p className="feature-desc">{service.desc}</p>
          </div>
        ))}

      </div>
    </div>
  );
};

export default Features;